import { render, staticRenderFns } from "./NotificacionesConfig.vue?vue&type=template&id=03e3d1c7&"
import script from "./NotificacionesConfig.vue?vue&type=script&lang=js&"
export * from "./NotificacionesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports